<template>
    <div id="app">
        <ynk-layout>
            <transition mode="out-in"
                        @enter="getAnimateIn"
                        @leave="getAnimateOut"
                        :css="false"
                        appear>
                <router-view :key="$route.path" ref="currentView"></router-view>
            </transition>
        </ynk-layout>
    </div>
</template>

<style lang="scss">
    @import './static/scss/app.scss';
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import { browserCheck } from '@/app/mixins';
    import Main from '@/app/layouts/Main';

    export default {
        name: 'App',

        components: {
            'ynk-layout': Main
        },

        mixins: [ browserCheck ],

        mounted()
        {
            this.$store.dispatch( 'determineFormAB', this.browserCheck.isMobile );
            this.$store.dispatch( 'setTicketAB', window._rootData.ticketAB );

            this.$store.dispatch( 'entry/merge', { origin: window.location.pathname });

            createjs.Sound.alternateExtensions = [ 'mp3' ];
            createjs.Sound.registerSound( '/static/sounds/tombola.mp3', 'tombola' );
            createjs.Sound.registerSound( '/static/sounds/koker.mp3', 'koker' );
            createjs.Sound.registerSound( '/static/sounds/vallen.mp3', 'vallen' );
            createjs.Sound.muted = true;

            // Mozilla/5.0 (iPad; CPU OS 9_3_5 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13G36 Safari/601.1
            if( this.browserCheck.isOldIOS )
            {
                document.documentElement.classList.add( 'ancient-safari' );
            }

            if( this.browserCheck.isIE )
            {
                document.documentElement.classList.add( 'is-ie' );
            }

            window.addEventListener( 'resize', this.onResize );
            this.onResize();
        },

        updated()
        {
            if( this.$route.query.sub_id )
            {
                window.Request_session_id = this.$route.query.sub_id;
                this.$store.dispatch( 'entry/merge', { origin: 'omg' });
            }
        },

        methods: {
            onResize()
            {
                document.documentElement.style.setProperty( '--vh100', window.innerHeight + 'px' ); // fix for 100vh on iphones
            },

            getAnimateIn( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateIn === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateIn(), 0 );
                }
            },

            getAnimateOut( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateOut === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateOut(), 0 );
                }
            }
        }
    };
</script>
